import { useGetTenantQuery } from './useGetTenantQuery';
import { OrgType } from '@/enums';

const useRootOrg = () => {
  const { tenant } = useGetTenantQuery();

  const { orgType = '' } = tenant;
  return orgType === OrgType.ROOT;
};

export default useRootOrg;
